import { eventReady, initializeGlobalDDO, initTHDObject, setPageData } from "./gather";

const Analytics = () =>
  Object.create({
    /**
     * Set the initial page-level information
     * @constructor
     */
    setPageView() {
      try {
        initTHDObject();
        initializeGlobalDDO();
        const pageData = {
          pageInfo: {
            pageName: "my account>security",
            pageType: "maml:security",
          },
          category: {
            primaryCategory: "my account",
            subCategory1: "my account",
            subCategory2: "my account>security",
          }
        };
        setPageData(pageData);
      } catch (e) {
        console.log("error in posting analytics for set page view", e);
      }
    },

    /**
     * Adds page-level information after initial load
     * @param pageData
     */
    addPageData(pageData) {
      try {
        setPageData(pageData);
      } catch (e) {
        console.log("error in adding page data", e);
      }
    },

    /**
     * @param identifier
     */
    postStashEvent(identifier) {
      try {
        const event = {
          category: {
            primaryCategory: "stash",
          },
          eventInfo: {
            eventName: "my account settings",
          },
          eventMode: "stash",
          stash: {
            myAccount: {
              settings: identifier
            }
          }
        };
        eventReady(event);
      } catch (e) {
        console.error("Error during analytics postStashEvent", e);
      }
    },

    /**
     * @param eventName
     */
    postSubmissionEvent(eventName) {
      try {
        const event = {
          category: {
            primaryCategory: "button submission",
          },
          eventInfo: {
            eventName
          }
        };
        eventReady(event);
      } catch (e) {
        console.error("Error during analytics postSubmissionEvent", e);
      }
    },

    /**
     * @param settings
     */
    postSettingsSubmissionEvent(settings) {
      try {
        const event = {
          category: {
            primaryCategory: "button submission"
          },
          eventInfo: {
            eventName: "my account settings"
          },
          myAccount: {
            settings
          }
        };
        eventReady(event);
      } catch (e) {
        console.error("Error during analytics postSettingsSubmissionEvent", e);
      }
    },

    postSettingsSubmissionEventWebauthn() {
      try {
        const event = {
          category: {
            primaryCategory: "button submission"
          },
          eventInfo: {
            eventName: "my account settings"
          },
          myAccount: {
            biometricEnablement: "completed"
          }
        };
        eventReady(event);
      } catch (e) {
        console.error("Error during analytics postSettingsSubmissionEvent", e);
      }
    },

    /**
     * Posts the post-page-load API errors
     * @param pageSection
     * @param code - error code from API
     * @param message - message shown to the user
     */
    postErrorEvent(pageSection, code, message) {
      try {
        const event = {
          category: {
            primaryCategory: "error",
          },
          eventInfo: {
            eventName: "post page error",
            error: [
              {
                type: "error",
                displayType: "inline",
                pageSection,
                message,
                code
              }
            ],
          },
        };
        eventReady(event);
      } catch (e) {
        console.log("error in postErrorEvent ", e);
      }
    },

    /**
     * posts overlay visibility
     * @param eventName
     */
    postOverlayEvent(eventName) {
      try {
        const event = {
          category: {
            primaryCategory: "overlay",
          },
          eventInfo: {
            eventName
          }
        };
        eventReady(event);
      } catch (e) {
        console.error("Error during analytics postOverlayEvent", e);
      }
    }

  });

const analytics = Analytics();

export default analytics;
